import { CommonMessages } from '../common.messages';

export const PanelAccountsEditMessages = {
    SearchClientFailed: {
        key: 'SearchUserFailed',
        message: 'Can\'t load other owner\'s trading accounts.'
    },
    CashBalancesFailed: {
        key: 'CashBalancesFailed',
        message: 'Can\'t load balances of account.'
    },
    GetLinkedAccountsFailed: {
        key: 'GetLinkedAccountsFailed',
        message: 'Can\'t load owner\'s bank accounts.'
    },
    OwnerLinkedAccountsNotFound: {
        key: 'OwnerLinkedAccountsNotFound',
        message: 'Owner hasn\'t linked bank accounts.'
    },
    OwnerActiveLinkedAccountsNotFound: {
        key: 'OwnerActiveLinkedAccountsNotFound',
        message: 'Owner hasn\'t active linked bank accounts.'
    },
    OwnerActiveGroupsNotFound: {
        key: 'OwnerActiveGroupsNotFound',
        message: 'Owner hasn\'t active cash accounts.'
    },
    OwnerActiveAccountsNotFound: {
        key: 'OwnerActiveAccountsNotFound',
        message: 'Owner hasn\'t active trading accounts.'
    },
    GetAccountDetailsFailed: {
        key: 'GetAccountDetailsFailed',
        message: 'Error while communication with a server. Can\'t get details about the trading account.'
    },
    AccountDetailsNotFound: {
        key: 'AccountDetailsNotFound',
        message: 'Error while communication with the server. Can\'t find details about the trading account.'
    },
    GetMasterAccountDetailsFailed: {
        key: 'GetMasterAccountDetailsFailed',
        message: 'Error while communication with a server. Can\'t get details about the cash account.'
    },
    MasterAccountDetailsNotFound: {
        key: 'MasterAccountDetailsNotFound',
        message: 'Error while communication with the server. Can\'t find details about the cash account.'
    },
    GetMasterTradingAccountsFailed: {
        key: 'GetMasterTradingAccountsFailed',
        message: 'Error while communication with a server. Can\'t get details about sub cash accounts.'
    },
    GetOwnerDetailsFailed: {
        key: 'GetOwnerDetailsFailed',
        message: 'Error while communication with a server. Can\'t get needed owner status.'
    },
    GetAccountStatusTriggersFailed: {
        key: 'GetAccountStatusTriggersFailed',
        message: 'Error while communication with a server. Can\'t get account status transitions.'
    },
    GetTradingAccountInfoFailed: {
        key: 'GetTradingAccountInfoFailed',
        message: 'Error while communication with a server. Can\'t get trading platforms and/or Account Info.'
    },
    GetClientFailed: {
        key: 'GetClientFailed',
        message: 'Error while communication with the server. Can\'t get details about account owner'
    },
    GetOwnerUsersFailed: {
        key: 'GetOwnerUsersFailed',
        message: 'Error while communication with the server. Unable to get account owner users.'
    },
    GetOwnerUsersNotFound: {
        key: 'GetOwnerUsersNotFound',
        message: 'Account owner doesn\'t have assigned users.'
    },
    GetOwnerHasNotActiveUsers: {
        key: 'GetOwnerHasNotActiveUsers',
        message: 'Account owner doesn\'t have active users.'
    },
    GetPermissionsFailed: {
        key: 'GetPermissionsFailed',
        message: 'Error while communication with the server. Unable to get available permission for assignment.'
    },
    GetPermissionsNotFound: {
        key: 'GetPermissionsNotFound',
        message: 'Error while communication with the server. Unable to find available permission for assignment.'
    },
    GetProductsFailed: {
        key: 'GetProductsFailed',
        message: 'Error while communication with the server. Unable to get products.'
    },
    GetOperatorFailed: {
        key: 'GetOperatorFailed',
        message: 'Error while communication with the server. Unable to get current operator.'
    },
    GetCashAccountDetailsFailed: {
        key: 'GetCashAccountDetailsFailed',
        message: 'Error while communication with the server. Unable to get related cash account details.'
    },
    GetProductsNotFound: {
        key: 'GetProductsNotFound',
        message: 'There are no available products at the moment.'
    },
    GetProductsOwnedFailed: {
        key: 'GetProductsOwnedFailed',
        message: `Error while communication with the server. Unable to get instruments in client's trading account.`
    },
    GetProductsOwnedNotFound: {
        key: 'GetProductsOwnedNotFound',
        message: `No available instruments in client's trading account.`
    },
    ...CommonMessages
};
